import { graphql } from '@/gql';
import type { ChargePartnerMutation, ChargePartnerMutationVariables } from '@/gql/graphql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export type ChargePartnerInput = ChargePartnerMutationVariables;

export type ChargePartnerOutput = ChargePartnerMutation['chargePartner'];

export const chargePartner = async ({
  amount,
  category,
  codeName,
  currency,
  notes,
  requestId,
  scheduledRideId,
}: ChargePartnerInput): Promise<ChargePartnerOutput> => {
  const response = await mutationExecute({
    mutation: graphql(`
      mutation ChargePartner(
        $currency: String!
        $amount: Float!
        $category: Float!
        $codeName: String!
        $notes: String!
        $requestId: String
        $scheduledRideId: Float
      ) {
        chargePartner(
          currency: $currency
          amount: $amount
          category: $category
          codeName: $codeName
          notes: $notes
          requestId: $requestId
          scheduledRideId: $scheduledRideId
        ) {
          id
        }
      }
    `),
    variables: {
      amount,
      category,
      codeName,
      currency,
      notes,
      requestId,
      scheduledRideId,
    },
  });

  return response.data?.chargePartner;
};
